import { GET_SUPPLY_ORDERS_QUERY } from 'data/queries/supplyOrder';
import { apolloClient } from '../../../App';

import { GetSupplyOrdersQuery, SupplyOrdersUpdatedOrCreatedSubscription } from 'data/__generated__';

export const deletedSupplyOrdersHandler = (deletedSupplyOrderIds: string[]) => {
    let currentSupplyOrders = [] as GetSupplyOrdersQuery['supplyOrders'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetSupplyOrdersQuery>({ query: GET_SUPPLY_ORDERS_QUERY });
        if (!result) {
            throw Error('An error occurred when reading GET_SITES_QUERY');
        }
        currentSupplyOrders = result.supplyOrders;
    } catch {
        // do nothing
    }

    const newSupplyOrders = currentSupplyOrders.filter(
        (supplyOrder) => !deletedSupplyOrderIds.includes(supplyOrder._id),
    );

    apolloClient.writeQuery({
        query: GET_SUPPLY_ORDERS_QUERY,
        data: { supplyOrders: newSupplyOrders },
    });
};

export const supplyOrdersUpdatedOrCreatedHandler = (
    supplyOrdersUpdatedOrCreated: SupplyOrdersUpdatedOrCreatedSubscription['supplyOrdersUpdatedOrCreated'],
) => {
    let currentSupplyOrders = [] as GetSupplyOrdersQuery['supplyOrders'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetSupplyOrdersQuery>({ query: GET_SUPPLY_ORDERS_QUERY });
        if (!result) {
            throw Error('An error occurred when reading GET_SUPPLY_ORDERS_QUERY');
        }
        currentSupplyOrders = result.supplyOrders;
    } catch {
        // do nothing
    }

    const updatedOrCreatedSupplyOrderIds = supplyOrdersUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedSupplyOrders = currentSupplyOrders.filter(
        ({ _id }) => !updatedOrCreatedSupplyOrderIds.includes(_id),
    );
    const newSupplyOrders = [...supplyOrdersUpdatedOrCreated, ...nonUpdatedOrCreatedSupplyOrders];

    apolloClient.writeQuery({
        query: GET_SUPPLY_ORDERS_QUERY,
        data: { supplyOrders: newSupplyOrders },
    });
};
